import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { useFormikContext } from "formik";

const ButtonWrapper = (props) => {
  const { children, disabled, onClick, variant, loading, color, ...other } =
    props;
  const { submitForm } = useFormikContext();

  const handleSubmit = () => {
    if (onClick) {
      onClick();
    } else {
      submitForm();
    }
  };

  const configButton = {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    disabled: disabled || loading,
    onClick: handleSubmit,
    ...other,
  };

  return (
    <Button {...configButton}>
      {loading ? (
        <CircularProgress
          size={25}
          fullWidth
          color="inherit"
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonWrapper;
